import React from 'react';
import styled from 'styled-components';
import BattlesCollectBase from './BattlesCollectBase';
import useBattlesCollect from 'shared/screens/Battles/hooks/useBattlesCollect';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';

const BattlesCollectStreak = props => {
  const isGrandReward = true;
  const data = useBattlesCollect({ ...props, isGrandReward });

  return (
    <Container $source={data?.battlesAssets?.BATTLES_GRAND_REWARD_POPUP}>
      <CloseButton src={assetSource(ASSET_KEY.CLOSE_BUTTON)} onClick={props.dismissModal} />
      <InfoWrapper>
        <BattlesCollectBase {...data} isGrandReward />
      </InfoWrapper>
    </Container>
  );
};

export default BattlesCollectStreak;

BattlesCollectStreak.hideDefaultBackground = true;
BattlesCollectStreak.hideCloseButton = true;
BattlesCollectStreak.AsModalProps = {
  dialogClassName: 'gtp-modal-battles-collect-streak',
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${({ $source }) => $source});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
`;

const CloseButton = styled.img`
  width: 4vw;
  height: 4vw;
  object-fit: contain;
  position: absolute;
  top: 8vw;
  right: 22.5vw;
  cursor: pointer;
`;

const InfoWrapper = styled.main`
  width: 49vw;
  height: 14vw;
  display: flex;
  position: relative;
  top: 10vw;
  align-items: center;
`;

